import { Link } from "react-router-dom";

const communities = [
  {
    icon: "ri-chat-3-line",
    title: "同人圈讨论",
    desc: "围绕角色、剧情与设定的同好交流区，分享你的追更感受与脑洞。",
    tag: "热聊中",
  },
  {
    icon: "ri-edit-2-line",
    title: "创作交流",
    desc: "同人创作者的灵感与经验分享，从设定考据到写作技巧一应俱全。",
    tag: "创作向",
  },
  {
    icon: "ri-magic-line",
    title: "二次创作活动",
    desc: "定期发起的同人创作主题活动，投稿参与，和同好一起玩转忍界。",
    tag: "活动",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "追更榜单",
    desc: "基于读者收藏与热度生成的双周榜单，快速发现口碑新作。",
    tag: "榜单",
  },
];

export default function Community() {
  return (
    <section className="border-y border-background-300/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-xs font-semibold tracking-widest text-accent-500">COMMUNITY</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              同人社区导航
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-400">
              从讨论区到创作活动，火影同人圈的热闹都汇聚于此。无论你是资深读者还是刚入坑的新人，都能找到属于自己的圈子。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {communities.map((c) => (
              <div
                key={c.title}
                className="group flex flex-col rounded-lg border border-background-300/60 bg-background-200/40 p-5 transition-colors hover:border-accent-500/40"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-accent-500">
                    <i className={`${c.icon} text-lg`} />
                  </span>
                  <span className="rounded-full bg-accent-500/10 px-2.5 py-1 text-[11px] text-accent-500">
                    {c.tag}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{c.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-400">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}